const development = process.env.NODE_ENV !== 'production'

export const MAIN_URL = development ? 'https://milaniautoclinic.ir/api/v1/' : '/api/v1/'
export const MAIN_URL_IMAGE = development ? 'https://milaniautoclinic.ir/' : ''
export const SITE_ADDRESS = 'https://milaniautoclinic.ir'
